import { render, staticRenderFns } from "./JEditorDyn.vue?vue&type=template&id=06cffe43&scoped=true"
import script from "./JEditorDyn.vue?vue&type=script&lang=js"
export * from "./JEditorDyn.vue?vue&type=script&lang=js"
import style0 from "./JEditorDyn.vue?vue&type=style&index=0&id=06cffe43&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cffe43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06cffe43')) {
      api.createRecord('06cffe43', component.options)
    } else {
      api.reload('06cffe43', component.options)
    }
    module.hot.accept("./JEditorDyn.vue?vue&type=template&id=06cffe43&scoped=true", function () {
      api.rerender('06cffe43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/dynamic/JEditorDyn.vue"
export default component.exports